// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Nz6ac","rightAdornment":"Header_rightAdornment__2Asqn"};